import React, { useState, useEffect, useCallback } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select'; // Importing React Select for multi-select dropdown
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Importing the data labels plugin

const colors = {
  'CIVIL': '#A569BD',   // Soft Purple  
  'CSE': '#28B463',     // Fresh Green  
  'ECE': '#1F618D',     // Deep Blue  
  'EEE': '#F5B041',     // Warm Gold  
  'MEC': '#85C1E9',     // Light Sky Blue  
  'IT': '#D35400',      // Rich Orange  
  'TT/FT':   "#00B4D8", // Vivid Turquoise  ,   // Teal Green  
  'MCT': '#D4AC0D',     // Mustard Yellow  
  'BME': "#FF3D7F", // Hot Pink  ,     // Dark Emerald  
  'ADS': '#2874A6',     // Ocean Blue  
  'AML': '#5D6D7E',     // Slate Gray  
  'CSD': '#E67E22',     // Bright Orange  
  'EFE': '#1ABC9C',     // Soft Cyan  
  'EXE': '#2E4053',     // Dark Steel  
  'CAP': "#83C5BE", // Light Aqua   // Charcoal Grey    // Warm Honey  
  'ENG': '#5499C7',     // Sky Blue  
  'GEN': '#48C9B0',     // Aquamarine  
  'HSC':  "#D4A5A5", // Dusty Pink  
  'MAT': '#52BE80',     // Fresh Mint  
  'MGT': '#AF7AC5',     // Soft Lavender  
  'TRA': '#34495E',     // Deep Navy  
};

const departmentNames = {
  '101': 'CIVIL',
  '102': 'CSE',
  '103': 'ECE',
  '104': 'EEE',
  '105': 'MEC',
  '106': 'IT',
  '107': 'TT/FT',
  '108': 'MCT',
  '109': 'BME',
  '110': 'ADS',
  '111': 'AML',
  '112': 'CSD',
  '113': 'EFE',
  '114': 'EXE',
  '215': 'CAP',
  '216': 'ENG',
  '217': 'GEN',
  '218': 'HSC',
  '219': 'MAT',
  '220': 'MGT',
  '221': 'TRA',
};

const canUpdatePatent = () => {
  const accessLevel = sessionStorage.getItem('access_level');
  const email = sessionStorage.getItem('email');

  // Only allow access if the user has access level 5 and the specific email
  return accessLevel == '7' ;
};

const PatentHome = () => {
  const history = useHistory();

  const [patents, setPatents] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPatents, setTotalPatents] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');
  const [selectedPatents, setSelectedPatents] = useState(new Set());
  const [pieChartData, setPieChartData] = useState(null);
  const [barChartData, setBarChartData] = useState(null);
  const [statusCounts, setStatusCounts] = useState({
    Filed: 0,
    Granted: 0,
    'Hearing in Progress': 0,
    Published: 0,
    'Hearing Completed': 0,
    'Patents granted and active': 0,
    'Patents granted but not renewed': 0,
    'Patents Legally Ceased': 0,
    'Application FER reply filed': 0,
    'Application in FER hearing': 0,
    'Applications requested for examination': 0,
    'Applications awaiting examination': 0,
    'Applications published': 0,
    'Applications awaiting publication': 0,
    'Applications awaiting complete specification': 0,
    'Applications refused': 0,
    'Applications Abandoned': 0,
  });

  const [uniqueStatuses, setUniqueStatuses] = useState([]); // State to hold unique statuses
  const [filterDepartment, setFilterDepartment] = useState(false);
  const [filteredPatentCount, setFilteredPatentCount] = useState(0);
  const [tableSelectedDepartments, setTableSelectedDepartments] = useState([]);
  const [tableFromDate, setTableFromDate] = useState('');
  const [tableToDate, setTableToDate] = useState([]);
 
  const[target,setTarget]=useState([]);
  const[tpcount,settpCount]=useState([]);

  // Function to update Pie Chart data
  const updatePieChartData = useCallback(
    (data) => {
      // Filter data by selected departments
      const filteredData = data.filter((patent) => {
        if (selectedDepartments.length === 0) {
          return true; // Include all patents if no department is selected
        }
        const departmentCode = patent.department.split(' ')[0]; // Get the first part (code)
        return selectedDepartments.includes(departmentCode);
      });

      const departmentCounts = filteredData.reduce((acc, patent) => {
        const departmentCode = patent.department.split(' ')[0]; // Get the department code
        const departmentName = departmentNames[departmentCode] || patent.department; // Get the department name
        acc[departmentName] = (acc[departmentName] || 0) + 1;
        return acc;
      }, {});

      const departments = Object.keys(departmentCounts);
      const counts = Object.values(departmentCounts);
      const colorsArray = departments.map(department => colors[department]);

      const formattedLabels = departments.map((department, index) => {
        return `${department} [${counts[index]}]`;
      });

      setPieChartData({
        labels: formattedLabels,
        datasets: [
          {
            data: counts,
            backgroundColor: colorsArray,
          },
        ],
      });
    },
    [selectedDepartments]
  );

  useEffect(() => {
    updatePieChartData(patents);
  }, [selectedDepartments, patents, updatePieChartData]);
  const fetchTarget = async () => {
    try {
        const startDate = tableFromDate ? tableFromDate : "";
        const endDate = tableToDate ? tableToDate : "";

        let targetUrl = `${process.env.REACT_APP_API_BASE_URL}/api/targets/${tableSelectedDepartments}/${startDate}/${endDate}`;
        const response = await fetch(targetUrl);

        if (!response.ok) throw new Error("Failed to fetch target");

        const data = await response.json();

        // ✅ First, update the state values before displaying Swal
        setTarget(data);
        settpCount(data.setPatentTarget);
        setFilteredPatentCount(searchedAndFilteredPatents.length); // Ensuring correct attained count

      // Delay to ensure state updates before showing alert
    setTimeout(() => {
      const updatedTpCount = data.setPatentTarget;
      const updatedTotalCount = searchedAndFilteredPatents.length;
      const remainingTarget = updatedTpCount - updatedTotalCount;

      // Calculate actual progress percentage (can be > 100%)
      let progressPercentage = ((updatedTotalCount / updatedTpCount) * 100).toFixed(2);
      // Cap progress bar width at 100%
      const barWidth = progressPercentage > 100 ? 100 : progressPercentage;

      Swal.fire({
        title: `<h2 style="color: #2C3E50; font-weight: bold; text-align: center; font-size: 20px; margin-bottom: 8px;">Target Details</h2>`,
        html: `
          <div style="border: 1px solid #ccc; border-radius: 10px; padding: 20px; background-color: #F8F9FA; text-align: left;">
            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;">
                <i class="fas fa-calendar-alt" style="color: #E67E22; margin-right: 6px;"></i><strong>Period:</strong>
              </div>
              <div style="font-size: 16px; color: #007bff;">
                ${startDate.substring(0, 4)} To ${endDate.substring(0, 4)}
              </div>
            </div>

            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;">
                <i class="fas fa-bullseye" style="color: #27AE60; margin-right: 6px;"></i><strong>Target:</strong>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #28a745;">
                ${updatedTpCount}
              </div>
            </div>

            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;">
                <i class="fas fa-check-circle" style="color: #17A2B8; margin-right: 6px;"></i><strong>Attained:</strong>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #17a2b8;">
                ${updatedTotalCount}
              </div>
            </div>

            <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
              <div style="font-size: 16px; color: #2C3E50;">
                <i class="fas fa-exclamation-circle" style="color: rgb(205, 146, 44); margin-right: 6px;"></i><strong>Remaining:</strong>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: ${remainingTarget <= 0 ? '#28a745' : '#17a2b8'};">
                ${Math.max(0, remainingTarget)}
              </div>
            </div>

            <div style="margin-top: 20px;">
              <strong>Progress:</strong>
              <div style="background-color: #ddd; border-radius: 5px; height: 20px; overflow: hidden; width: 100%;">
                <div style="background-color: #28a745; height: 100%; width: ${barWidth}%; text-align: center; color: white; font-weight: bold;">
                  ${progressPercentage}%
                </div>
              </div>
            </div>

            ${remainingTarget <= 0 ? `
              <div style="text-align: center; margin-top: 20px; padding: 10px; background-color: #E8F8E9; border-radius: 8px;">
                <p style="color: #28a745; font-weight: bold; font-size: 18px; margin: 0;">
                  🎉 Great Job! You've met or exceeded your target! 🎉
                </p>
              </div>
            ` : ''}
          </div>
        `,
        icon: remainingTarget <= 0 ? "success" : "success",
        confirmButtonText: "<i class='fas fa-thumbs-up'></i> OK",
        showCloseButton: true,
        background: "#FDFEFE",
        color: "#2C3E50",
        width: "500px",
        padding: "15px",
      });
    }, 500);
        updateAttainedPatentTarget(data.targetId, data.setPatentTarget);
    } catch (error) {
        Swal.fire({
            title: "Error!",
            text: "Failed to fetch target data.",
            icon: "error",
            confirmButtonText: "OK",
        });
        console.error("Error fetching target:", error);
    }
};

  
const updateAttainedPatentTarget = async (targetId, tpcount) => {
  try {
    const updateUrl = `${process.env.REACT_APP_API_BASE_URL}/api/targets/${targetId}/updateAttainedPatentTarget?newAttainedPatentTarget=${filteredPatentCount}`;
    
    const response = await fetch(updateUrl, {
      method: "PUT",
    });

    if (!response.ok) {
      throw new Error("Failed to update the patent target");
    }

    const data = await response.text(); // Expecting a plain text response
    console.log("Successfully updated patent target:", data);
  } catch (error) {
    console.error("Error updating the patent target:", error);
  }
};


  // Function to update Bar Chart data
  const updateBarChartData = useCallback(
    (data) => {
      // Filter data by date range
      const filteredData = fromDate && toDate
        ? data.filter((patent) => {
            const filingDate = new Date(patent.filingDate);
            const from = fromDate ? new Date(fromDate) : new Date('1900-01-01');
            const to = toDate ? new Date(toDate) : new Date();
            return filingDate >= from && filingDate <= to;
          })
        : data;

      // Group patents by department
      const departmentCounts = filteredData.reduce((acc, patent) => {
        const departmentCode = patent.department.split(' ')[0]; // Get the department code
        const departmentName = departmentNames[departmentCode] || patent.department; // Get the department name
        acc[departmentName] = (acc[departmentName] || 0) + 1;
        return acc;
      }, {});

      const departments = Object.keys(departmentCounts);
      const counts = Object.values(departmentCounts);
      const totalPatents = filteredData.length;

      // Assign a different color to each bar based on the department
      const barColors = departments.map(department => colors[department]);

      setBarChartData({
        labels: departments,
        datasets: [
          {
            label: 'Number of Patents',
            data: counts,
            backgroundColor: barColors,
          },
        ],
      });

      setTotalPatents(totalPatents);
    },
    [fromDate, toDate]
  );

  // Function to calculate status counts
  const calculateStatusCounts = (data) => {
    const statusCounts = {
      Filed: 0,
      Granted: 0,
      'Hearing in Progress': 0,
      Published: 0,
      'Hearing Completed': 0,
      'Patents granted and active': 0,
      'Patents granted but not renewed': 0,
      'Patents Legally Ceased': 0,
      'Application FER reply filed': 0,
      'Application in FER hearing': 0,
      'Applications requested for examination': 0,
      'Applications awaiting examination': 0,
      'Applications published': 0,
      'Applications awaiting publication': 0,
      'Applications awaiting complete specification': 0,
      'Applications refused': 0,
      'Applications Abandoned': 0,
    };

    data.forEach((patent) => {
      if (patent.status === 'Filed') {
        statusCounts['Filed']++;
      } else if (patent.status === 'Granted') {
        statusCounts['Granted']++;
      } else {
        // For all other statuses, increment the 'Published' count
        statusCounts['Published']++;
      }
    });

    setStatusCounts(statusCounts);
    setUniqueStatuses(Object.keys(statusCounts)); // Set unique statuses for the dropdown
  };

  const handleResetFilters = () => {
    setFromDate('');
    setToDate('');
    setSelectedDepartments([]);
    setStatusFilter('');
    setSearchQuery('');
    setSelectedPatents(new Set());
    setTotalPatents(0);
    updatePieChartData(patents);
    updateBarChartData(patents);
  };

  // Function to fetch patents
  const fetchPatents = async () => {
    try {
      let allPatents = [];
      let nextPageUrl = `${process.env.REACT_APP_API_BASE_URL}/api/patents`;
     
      
      while (nextPageUrl) {
        if (nextPageUrl.startsWith('http://') && process.env.REACT_APP_API_BASE_URL?.startsWith('https://')) {
          nextPageUrl = nextPageUrl.replace('http://', 'https://');
        }
        const response = await fetch(nextPageUrl);
        if (!response.ok) {
          throw new Error('Failed to fetch patents');
        }

        
      

        const data = await response.json();
        allPatents = [...allPatents, ...data._embedded.patents];

        nextPageUrl = data._links && data._links.next ? data._links.next.href : null;
      }

      setPatents(allPatents);
      setTotalCount(allPatents.length);
      calculateStatusCounts(allPatents);
      updatePieChartData(allPatents);
      updateBarChartData(allPatents);
  
     
          
    } catch (error) {
      console.error('Error fetching patents:', error);
    }
  };

  useEffect(() => {
    fetchPatents();
   
  }, [updatePieChartData, updateBarChartData]);

  const handleDeleteSelected = async () => {
    const idsToDelete = Array.from(selectedPatents);
    try {
      const deletePromises = idsToDelete.map((patentId) =>
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/patents/${patentId}`, {
          method: 'DELETE',
        })
      );

      const responses = await Promise.all(deletePromises);
      const allDeleted = responses.every((response) => response.ok);

      if (allDeleted) {
        setPatents((prevPatents) => prevPatents.filter((patent) => !idsToDelete.includes(patent.id)));
        alert("Selected patents deleted successfully.");
      } else {
        alert("Failed to delete some patents.");
      }
    } catch (error) {
      console.error('Error:', error);
      alert("An error occurred while deleting the patents.");
    }
  };

  const togglePatentSelection = (id) => {
    setSelectedPatents((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(id)) {
        newSelected.delete(id);
      } else {
        newSelected.add(id);
      }
      return newSelected;
    });
  };

  const applyPieChartFilter = () => {
    updatePieChartData(patents);
  };

  const applyBarChartFilter = () => {
    updateBarChartData(patents);
  };

  const filteredPatents = filterDepartment ? patents.filter((patent) => {
    const departmentCode = patent.department.split(' ')[0]; // Get the first part (code)
    const filingDate = new Date(patent.filingDate);
    const from = tableFromDate ? new Date(tableFromDate) : new Date('1900-01-01');
    const to = tableToDate ? new Date(tableToDate) : new Date();

    return (
      (tableSelectedDepartments.length === 0 || tableSelectedDepartments[0] === departmentCode) &&
      (filingDate >= from && filingDate <= to)
    );
  }) : patents;

  // Implementing search and status filter
  const searchedAndFilteredPatents = filteredPatents.filter((patent) => {
    const matchesTitle = patent.title.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter ? patent.status === statusFilter : true;
    return matchesTitle && matchesStatus;
  });

  const itemsPerPage = 100;
  const totalPages = searchedAndFilteredPatents.length ? Math.ceil(searchedAndFilteredPatents.length / itemsPerPage) : 0;
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedPatents = searchedAndFilteredPatents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Define the custom plugin for displaying values inside the bars
  const valueInsideBarPlugin = {
    id: "valueInsideBar",
    afterDatasetsDraw: (chart) => {
      const { ctx } = chart;
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        meta.data.forEach((bar, index) => {
          const value = dataset.data[index];
          ctx.fillStyle = "#fff"; // Text color inside the bar
          ctx.font = "12px Arial"; // Text font and size
          ctx.textAlign = "center";
          ctx.textBaseline = "middle"; // Position the text inside the bar
          const positionX = bar.x;
          const positionY = bar.y + (bar.height / 2);
          ctx.fillText(value, positionX, positionY);
        });
      });
    },
  };
  setTimeout(() => {
    localStorage.setItem("patent_total", totalCount);
    
}, 1400); // 1-second delay
  return (
    <div className="" style={{paddingLeft: '20px',  // Adjust as needed
      paddingRight: '20px'  // Adjust as needed
  }}>
      <div className="mb-4">
        <h3>Total Patents: {totalCount}</h3>
        <div className="col-auto d-flex justify-content-end m-2">
  {/* Conditionally render the "Add" h6 */}
  {canUpdatePatent() && (
    <h6
    className="p-2 text-center border rounded text-light"
    style={{
      cursor: 'pointer',
      width: '90px',
      textAlign: 'center',
      backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
      transition: 'background-color 0.3s, color 0.3s', // Smooth transition
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = '#004085'; // Gray color on hover
      e.target.style.color = 'white'; // Ensure text remains readable
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
      e.target.style.color = 'white'; // Original text color
    }}
    onClick={() => history.push("/update-patent")}
  >
    AddPatent
  </h6>
  )}

  {/* Conditionally render the "Delete" h6 */}
  {canUpdatePatent() && (
    <h6
    className="p-2 text-center border rounded text-light"
    style={{
      cursor: 'pointer',
      width: '120px',
      textAlign: 'center',
      backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
      transition: 'background-color 0.3s, color 0.3s', // Smooth transition
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = '#004085'; // Gray color on hover
      e.target.style.color = 'white'; // Ensure text remains readable
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
      e.target.style.color = 'white'; // Original text color
    }}
    onClick={handleDeleteSelected}
  >
    DeletePatents
  </h6>
  )}
</div>
<div className="row mb-3">
  <div className="col-md-4">
    <div 
      style={{
        backgroundColor: '#B2A4D4', 
        padding: '10px', 
        borderRadius: '5px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
      }}
    >
      <h5>Filed: {statusCounts.Filed}</h5>
    </div>
  </div>
  <div className="col-md-4">
    <div 
      style={{
        backgroundColor: '#FFC107', 
        padding: '10px', 
        borderRadius: '5px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
      }}
    >
      <h5>Published: {statusCounts.Published}</h5>
    </div>
  </div>
  <div className="col-md-4">
    <div 
      style={{
        backgroundColor: '#74C476', 
        padding: '10px', 
        borderRadius: '5px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
      }}
    >
      <h5>Granted: {statusCounts.Granted}</h5>
    </div>
  </div>



         
          {/*<div className="col-md-3">
            <div style={{ backgroundColor: '#0DCAF0', padding: '10px', borderRadius: '5px' }}>
              <h5>Hearing in Progress: {statusCounts['Hearing in Progress']}</h5>
            </div>
          </div>*/}
          
          
        </div>
      </div>

      {/* Filter Section */}
      <div className="row mb-4">
        <div className="col-md-6">
          <h5>Comparative Analysis (Choose more than one Department)</h5>
          <Select
            options={Object.entries(departmentNames).map(([code, name]) => ({
              value: code,
              label: name,
            }))}
            isMulti
            onChange={(selectedOptions) => {
              const values = selectedOptions.map(option => option.value);
              setSelectedDepartments(values);
            }}
            className="mb-2"
          />
        </div>

        <div className="col-md-6">
          <h5>Filter by Year</h5>
          <div className="d-flex align-items-center">
            <input
              type="date"
              className="form-control me-2"
              onChange={(e) => setFromDate(e.target.value)}
              value={fromDate}
            />
            <span className="me-2">to</span>
            <input
              type="date"
              className="form-control me-2"
              onChange={(e) => setToDate(e.target.value)}
              value={toDate}
            />
            <button className="btn btn-primary" onClick={applyBarChartFilter}>
              Apply
            </button>
            <button className="btn btn-secondary ms-2" onClick={handleResetFilters}>
              Reset 
            </button>
          </div>
        </div>
      </div>

      {/* Charts Section */}
      <div className="row mt-4">
        <div className="col-md-6">
          <h5>Patents by Department</h5>
          <div style={{ height: '300px' }}>
            {pieChartData ? (
              <Pie 
                data={pieChartData} 
                options={{
                  responsive: true, 
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      labels: {
                        font: {
                          weight: 'normal',
                        },
                      },
                    },
                    tooltip: {
                      callbacks: {
                        label: function (tooltipItem) {
                          const label = tooltipItem.label || '';
                          const count = tooltipItem.raw || 0;
                          return `${label} [${count}]`;
                        },
                      },
                      bodyFont: {
                        weight: 'normal',
                        color: '#000',
                        size: 16,
                      },
                      titleFont: {
                        weight: 'normal',
                      },
                    },
                  },
                }}
              />
            ) : (
              <p>No data available</p>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <h5>Patents by Year</h5>
          <div>
            <strong>Total Patents: {totalPatents}</strong>
          </div>
          <div style={{ height: '300px' }}>
            {barChartData ? (
              <Bar 
                data={barChartData} 
                options={{ 
                  responsive: true, 
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: true,
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      formatter: (value) => value,
                    },
                    valueInsideBar: true, // Enable the custom plugin
                  },
                }} 
                plugins={[valueInsideBarPlugin]} // Add the custom plugin here
              />
            ) : (
              <p>No data available</p>
            )}
          </div>
        </div>
      </div>

      {/* Buttons and Filters Row */}
      <div className="row mb-4 align-items-center">
        <div className="col-auto">
          
        </div>

        <div className="col-auto">
          <label htmlFor="searchTitle" className="form-label me-2">Search Patent by Title</label>
          <input
            type="text"
            id="searchTitle"
            className="form-control"
            placeholder="Search by Title"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="col-auto">
          <label htmlFor="statusFilter" className="form-label me-2">Filter Patent by Status</label>
          <select
            id="statusFilter"
            className="form-select"
            onChange={(e) => setStatusFilter(e.target.value)}
            value={statusFilter}
          >
            <option value="">All Patents</option>
            {uniqueStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div className="col-auto">
  <label className="form-label me-2">Check Target</label>
  <input
    type="checkbox"
    id="filterDepartment"
    className="form-check-input me-2"
    checked={filterDepartment}
    onChange={(e) => setFilterDepartment(e.target.checked)}
  />
  
  {filterDepartment && (
    <div className="mt-2">
      {/* Department Dropdown */}
      <Select
        options={Object.entries(departmentNames).map(([code, name]) => ({
          value: code,
          label: name,
        }))}
        onChange={(selectedOption) => setTableSelectedDepartments([selectedOption.value])}
        className="mb-2"
      />

      {/* Academic Year Selection */}
      <div className="d-flex align-items-center">
        {/* From Date - Academic Year Start */}
        <select
          className="form-control me-2"
          onChange={(e) => {
            const selectedYear = e.target.value;
            setTableFromDate(`${selectedYear}-07-01`); // Always start from July 1
            setTableToDate(`${parseInt(selectedYear) + 1}-06-30`); // End at June 30 of next year
          }}
          value={tableFromDate ? tableFromDate.split("-")[0] : ""}
        >
          <option value="">Select Academic Year</option>
          {[...Array(30)].map((_, index) => {
            const year = new Date().getFullYear() - index;
            return (
              <option key={year} value={year}>
                {year}
              </option>
            );
          })}
        </select>

        <span className="me-2">to</span>

        {/* To Date - Automatically Set (Read-Only) */}
        <input
          type="text"
          className="form-control me-2"
          value={tableToDate ? String(tableToDate).split("-")[0] : ""}
          disabled
        />
      </div>

      {/* Apply Filter Button */}
      <button
        className="btn btn-primary mt-2"
        onClick={() => {
          fetchTarget(); // Call the fetchTarget function
          setFilteredPatentCount(searchedAndFilteredPatents.length); // Update the filtered patent count
        }}
        disabled={!tableFromDate} // Disable if no year is selected
      >
        Find
      </button>
    </div>
  )}
</div>

      </div>

      
      <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
        <table className="table table-striped table-bordered table-hover rounded-5">
  <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
            <tr>
              <th className='bg-secondary'>Select</th>
              <th className='bg-secondary'>Patent ID</th>
              <th className='bg-secondary'>Title</th>
              <th className='bg-secondary'>Status</th>
              <th className='bg-secondary'>Department</th>
              <th className='bg-secondary'>Application Number</th>
              <th className='bg-secondary'>Technology Readiness Level</th>
              <th className='bg-secondary'>Filing Date</th>
              <th className='bg-secondary'>Commercialized</th>
              <th className='bg-secondary'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedPatents.map((patent, i) => (
              <tr key={i}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedPatents.has(patent.id)}
                    onChange={() => togglePatentSelection(patent.id)}
                  />
                </td>
                <td>{patent.id}</td>
                <td>{patent.title}</td>
                <td>{patent.status}</td>
                <td>{departmentNames[patent.department.split(' ')[0]] || patent.department}</td>
                <td>{patent.applicationNumber}</td>
                <td>{patent.technologyReadinessLevel}</td>
                <td>{patent.filingDate}</td>
                <td>
        {/* Add the console log here */}
        {console.log('Commercialized:', patent.commercialized)}
        {patent.commercialized === 'yes' ? 'Yes' : 'No'}
      </td>
                <td>
                  <button
                    className="btn btn-info"
                    onClick={() => history.push(`/patent-details/${patent.id}`)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-secondary"
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-secondary"
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PatentHome;